import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 12l-5-5-5 5z"
});

var SvgCaretUpMinor = function SvgCaretUpMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgCaretUpMinor as S };
